import { Controller } from "@hotwired/stimulus"

// The server renders every suggestion into a Turbo Frame. This only debounces
// the lookup, moves the highlight, and copies the chosen code into the hidden
// field the form actually submits.
export default class extends Controller {
  static targets = ["value", "query", "results"]
  static values = { url: String, field: String, delay: { type: Number, default: 200 } }

  disconnect() {
    clearTimeout(this.timer)
  }

  search() {
    this.valueTarget.value = ""
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), this.delayValue)
  }

  load() {
    const query = this.queryTarget.value.trim()
    if (query.length < 2) return this.close()

    const params = new URLSearchParams({ q: query, field: this.fieldValue })
    this.resultsTarget.src = `${this.urlValue}?${params}`
  }

  choose(event) {
    const option = event.currentTarget
    this.valueTarget.value = option.dataset.iata
    this.queryTarget.value = option.dataset.label
    this.close()
    this.queryTarget.focus()
  }

  navigate(event) {
    if (event.key === "Escape") return this.close()

    const options = this.options
    if (options.length === 0) return

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()
      const step = event.key === "ArrowDown" ? 1 : -1
      const current = options.indexOf(document.activeElement)
      const next = current === -1 ? 0 : (current + step + options.length) % options.length
      options[next].focus()
    } else if (event.key === "Enter" && options.includes(document.activeElement)) {
      event.preventDefault()
      document.activeElement.click()
    }
  }

  // Moving into a suggestion blurs the input, so only close when focus has left
  // the picker entirely — otherwise arrowing down would clear the list.
  dismiss(event) {
    if (event.relatedTarget && this.element.contains(event.relatedTarget)) return

    this.timer = setTimeout(() => this.close(), 150)
  }

  close() {
    clearTimeout(this.timer)
    this.resultsTarget.removeAttribute("src")
    this.resultsTarget.innerHTML = ""
  }

  get options() {
    return Array.from(this.resultsTarget.querySelectorAll("[role=option]"))
  }
}
